import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Laura M.',
  city: 'Buenos Aires',
  initials: 'LM',
  product: 'Megapack Terapia Resuelta',
  time: 'hace 2 min'
}, {
  name: 'Mariela C.',
  city: 'Rosario',
  initials: 'MC',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 5 min'
}, {
  name: 'Sofía V.',
  city: 'Córdoba',
  initials: 'SV',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 8 min'
}, {
  name: 'Florencia L.',
  city: 'Tucumán',
  initials: 'FL',
  product: 'Megapack Terapia Resuelta',
  time: 'hace 12 min'
}, {
  name: 'Ana R.',
  city: 'Mendoza',
  initials: 'AR',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 15 min'
}, {
  name: 'Valeria T.',
  city: 'Santa Fe',
  initials: 'VT',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 18 min'
}, {
  name: 'Gabriela R.',
  city: 'Salta',
  initials: 'GR',
  product: 'Megapack Terapia Resuelta',
  time: 'hace 22 min'
}, {
  name: 'Carolina P.',
  city: 'La Plata',
  initials: 'CP',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 25 min'
}, {
  name: 'Daniela S.',
  city: 'Mar del Plata',
  initials: 'DS',
  product: 'Megapack Terapia Resuelta',
  time: 'hace 30 min'
}, {
  name: 'Julieta F.',
  city: 'Neuquén',
  initials: 'JF',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 35 min'
}, {
  name: 'Romina G.',
  city: 'San Juan',
  initials: 'RG',
  product: 'Megapack Terapia Resuelta',
  time: 'hace 40 min'
}, {
  name: 'Luciana B.',
  city: 'Paraná',
  initials: 'LB',
  product: 'Megapack + Consultorio Rentable™',
  time: 'hace 45 min'
}];
const avatarColors: Record<string, string> = {
  LM: '#6d28d9',
  MC: '#7c3aed',
  SV: '#b45309',
  FL: '#065f46',
  AR: '#9f1239',
  VT: '#1d4ed8',
  GR: '#92400e',
  CP: '#6d28d9',
  DS: '#7c3aed',
  JF: '#065f46',
  RG: '#b45309',
  LB: '#1d4ed8'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 6000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  return <div className="fixed bottom-4 left-4 z-50" style={{
    maxWidth: 'calc(100vw - 32px)'
  }} data-id="element-284">
      {purchase && <div className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 shadow-lg max-w-sm" style={{
      border: '1px solid rgba(109, 40, 217, 0.3)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
      transition: 'opacity 0.35s ease-out, transform 0.35s ease-out',
      pointerEvents: visible ? 'auto' : 'none'
    }} data-id="element-285">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: avatarColors[purchase.initials] ?? '#7c3aed'
      }} data-id="element-286">
            {purchase.initials}
          </div>
          <div className="min-w-0 flex-1" data-id="element-287">
            <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-288">
              {purchase.name} de {purchase.city}
            </p>
            <p className="text-[10px] text-gray-600 m-0 truncate" data-id="element-289">
              compró el{' '}
              <span className="font-semibold" style={{
            color: '#7c3aed'
          }} data-id="element-290">
                {purchase.product}
              </span>
            </p>
            <p className="text-[9px] text-gray-400 m-0 mt-0.5" data-id="element-291">
              🕐 {purchase.time}
            </p>
          </div>
          <div className="shrink-0" data-id="element-292">
            <span className="text-[9px] font-bold text-green-600 bg-green-50 border border-green-200 rounded-full px-1.5 py-0.5" data-id="element-293">
              ✓ Verificado
            </span>
          </div>
        </div>}
    </div>;
}